import { useEffect } from "react";

export const useNoIndex = (title) => {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    const previous = document.title;
    document.title = title;
    return () => { meta.remove(); document.title = previous; };
  }, [title]);
};

export const PreviewToolbar = ({ heading, options, active, onSelect, testId = "hero-options-toolbar", descriptionTestId = "hero-options-description", buttonPrefix = "hero-switcher-btn" }) => (
  <div data-testid={testId} className="sticky top-[68px] md:top-[72px] z-40 bg-white/90 backdrop-blur-xl border-b hairline">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-2.5 sm:py-3 flex flex-col lg:flex-row lg:items-center gap-2 sm:gap-3 lg:gap-8">
      <div className="min-w-0 lg:flex-1">
        <p className="font-mono-label text-[10px] !tracking-normal text-[#5F6168]">{heading}</p>
        <p data-testid={descriptionTestId} aria-live="polite" className="hidden sm:block mt-1 text-sm text-[#3D4049] leading-snug">{active.blurb}</p>
      </div>
      <div role="group" aria-label="Choose an option" className="flex flex-wrap sm:flex-nowrap gap-1.5 sm:overflow-x-auto sm:-mx-1 sm:px-1 sm:pr-8 lg:pr-1 pb-0.5 shrink-0 sm:[mask-image:linear-gradient(to_right,#000_82%,transparent)] lg:[mask-image:none]">
        {options.map((option) => (
          <button key={option.id} type="button" data-testid={`${buttonPrefix}-${option.id}`} aria-pressed={option.id === active.id} onClick={() => onSelect(option.id)}
            className={`shrink-0 font-mono-label text-[10px] !tracking-normal px-3 sm:px-3.5 py-2 sm:py-2.5 border transition-colors ${option.id === active.id ? "bg-[#0F1117] text-white border-[#0F1117]" : "bg-white text-[#0F1117] border-[#D5D8DD] hover:border-[#0F1117]"}`}>
            <span className="sm:hidden">{option.short}</span><span className="hidden sm:inline">{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  </div>
);
